var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLike = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99642 14.6667V7.33337M1.66309 8.66671V13.3334C1.66309 14.0698 2.26004 14.6667 2.99642 14.6667H11.9472C12.9344 14.6667 13.7739 13.9465 13.924 12.9708L14.6419 8.30415C14.8283 7.09264 13.891 6.00004 12.6652 6.00004H10.3298C9.96156 6.00004 9.66309 5.70156 9.66309 5.33337V2.97727C9.66309 2.06937 8.92709 1.33337 8.01919 1.33337C7.80264 1.33337 7.60641 1.4609 7.51846 1.65879L5.17238 6.93747C5.06538 7.17822 4.82663 7.33337 4.56317 7.33337H2.99642C2.26004 7.33337 1.66309 7.93033 1.66309 8.66671Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/like.6ac66db0.svg";
export { ForwardRef as ReactComponent };